export default __webpack_public_path__ + "static/media/arrow-left.f0c00e42.svg";